/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNameAndOwnershipData_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly legalBusinessName: string | null, readonly preferredAccountName: string | null, readonly website: string | null, readonly ownership: _Types.CreditApplicationBusinessOwnership | null, readonly naicsCode: string | null, readonly industry: string | null, readonly formedOn: any | null, readonly entityType: _Types.CreditApplicationBusinessEntity | null, readonly taxIdLastFour: string | null, readonly numberOfEmployees: number | null };

export type GetNameAndOwnershipData_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly businessInfo: GetNameAndOwnershipData_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null };

export type GetNameAndOwnershipData_Query = { readonly __typename: 'Query', readonly creditApplication: GetNameAndOwnershipData_creditApplication_CreditApplication | null };


export type GetNameAndOwnershipDataVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetNameAndOwnershipData = GetNameAndOwnershipData_Query;


export const GetNameAndOwnershipDataDocument = gql`
    query GetNameAndOwnershipData($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    businessInfo {
      legalBusinessName
      preferredAccountName
      website
      ownership
      naicsCode
      industry
      formedOn
      entityType
      taxIdLastFour
      numberOfEmployees
    }
  }
}
    `;

/**
 * __useGetNameAndOwnershipData__
 *
 * To run a query within a React component, call `useGetNameAndOwnershipData` and pass it any options that fit your needs.
 * When your component renders, `useGetNameAndOwnershipData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNameAndOwnershipData({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetNameAndOwnershipData(baseOptions: Apollo.QueryHookOptions<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables> & ({ variables: GetNameAndOwnershipDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables>(GetNameAndOwnershipDataDocument, options);
      }
export function useGetNameAndOwnershipDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables>(GetNameAndOwnershipDataDocument, options);
        }
export function useGetNameAndOwnershipDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables>(GetNameAndOwnershipDataDocument, options);
        }
export type GetNameAndOwnershipDataHookResult = ReturnType<typeof useGetNameAndOwnershipData>;
export type GetNameAndOwnershipDataLazyQueryHookResult = ReturnType<typeof useGetNameAndOwnershipDataLazyQuery>;
export type GetNameAndOwnershipDataSuspenseQueryHookResult = ReturnType<typeof useGetNameAndOwnershipDataSuspenseQuery>;
export type GetNameAndOwnershipDataQueryResult = Apollo.QueryResult<GetNameAndOwnershipData, GetNameAndOwnershipDataVariables>;